export function getAppEnv() {
  return process.env.REACT_APP_ENV;
}

export function getLogInRedirectUrl() {
  return `/login`;
}
